

export const githubConfig = {
    clientId: "ac56fad434a3a3c1561e"
}